import { checkUserPermissions } from '@/services/auth';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';

//import Notifications from './screens/index.vue';
const Notifications = () => import('./screens/index.vue')

const notificationsRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.NOTIFICATION_VIEW,
    PERMISSIONS_KEYS.NOTIFICATION_INSERT,
    PERMISSIONS_KEYS.NOTIFICATION_EDIT,
  ])
) {
  notificationsRoutes.push({
    path: '/notificacoes',
    name: 'Cadastro / Consulta|Notificações',
    component: Notifications,
    meta: {
      icon: 'fa-envelope',
      requiresAuth: true,
    },
  });
}

export { notificationsRoutes };

